import { render, staticRenderFns } from "./card-shops.vue?vue&type=template&id=54b193e5&scoped=true&"
import script from "./card-shops.vue?vue&type=script&lang=js&"
export * from "./card-shops.vue?vue&type=script&lang=js&"
import style0 from "./card-shops.vue?vue&type=style&index=0&id=54b193e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b193e5",
  null
  
)

export default component.exports